import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getExchangeHolidays, getSpecialSession } from '@/api/datafeed.api';

export const fetchHolidays = createAsyncThunk(
  'market/fetchHolidays',
  async (exchange, { rejectWithValue }) => {
    const res = await getExchangeHolidays(exchange);
    if (!res) return rejectWithValue('Failed to fetch holidays');
    return res?.data?.NFO || [];
  }
);

export const fetchSpecialSessions = createAsyncThunk(
  'market/fetchSpecialSessions',
  async (_, { rejectWithValue }) => {
    const res = await getSpecialSession();
    if (!res) return rejectWithValue('Failed to fetch special sessions');
    return res?.data?.NFO || [];
  }
);

const marketSlice = createSlice({
  name: 'market',
  initialState: {
    holidays: [],
    specialSessions: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHolidays.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHolidays.fulfilled, (state, action) => {
        state.loading = false;
        state.holidays = action.payload;
      })
      .addCase(fetchHolidays.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSpecialSessions.fulfilled, (state, action) => {
        state.specialSessions = action.payload;
      });
  },
});

export default marketSlice.reducer;
